import { createSlice } from '@reduxjs/toolkit';
import { fetchCategories } from '../actions/category.action';

const initialState = {
  categories: {
    data: [],
    isLoading: false,
    isNeedReloadData: true,
  },
};

export const categoryReducer = createSlice({
  name: 'Category',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchCategories.pending, state => {
        state.categories.isLoading = true;
        state.categories.isNeedReloadData = false;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        if (action.payload) {
          const { data } = action.payload;
          state.categories = {
            ...state.categories,
            data,
            isLoading: false,
          };
        }
      });
  },
});

// export const {} = categoryReducer.actions;

export default categoryReducer.reducer;
